"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var each_1 = require("./each");
var matches_1 = require("./matches");
exports.children = function (element, selector) {
    var nodes = [];
    if (element.children.length > 0) {
        each_1.each(function (child) {
            if (selector === undefined || matches_1.matches(child, selector)) {
                nodes.push(child);
            }
        }, element.children);
    }
    return nodes;
};
